.subscriptionCardContainer {
  padding: var(--cxy-spacing-sm) var(--cxy-spacing-xsm);
}
@media (--cxy-tablet) {
  .subscriptionCardContainer {
    padding: var(--cxy-spacing-md) var(--cxy-spacing-lg);
  }
}
@media (--cxy-desktop-mid) {
  .subscriptionCardContainer {
    padding: var(--cxy-spacing-md) 100px;
  }
}
.subscriptionCardContainer .tabsList {
  margin-block-end: var(--cxy-spacing-md);
}

.textContainer {
  padding-block-start: var(--cxy-spacing-sm);
}
